<template>
 <div>
    <div
      class="poster-content"
      :style="{
      maxHeight,
      }"
    >
      <div class="flex space-between">
         <div class="text-left">
            <img
              crossOrigin="anonymous"
              width="72px"
              src="https://img.alicdn.com/imgextra/i2/2211227103034/O1CN01AFY2Yl1YHcRReMH4g_!!2211227103034.png"
              alt=""
            />
            <div class="ftsz20 mgt16 text-bold text-333">
                {{this.cardName || userInfo.companyName}}
            </div>
            <div class="text-grayer mgt16" style="font-size:15px; color: #52555A;">
                邀您看精选好货
            </div>
        </div>
        <div
           class="pd4"
           style="background: #fff; width: 98px; height: 98px; border-radius: 4px;"
        >
          <img
            width="100%"
            :src="`https://scm.superboss.cc/api/wx/unAuth/proxy.json?pic=${wxCodeUrl}`"
          />
        </div>
      </div>
      <div class="mgt28">
        <div v-if="goodsList.length === 0">
          <img
            width="100%"
            src="https://img.alicdn.com/imgextra/i1/2211227103034/O1CN012lJCiP1YHcRKrMD6W_!!2211227103034.png"
            alt=""
          >
        </div>
        <div v-else>
            <div v-if="editing">
                <div
                    v-for="(item, index) in editingGoodsList"
                    :key="item.baseItemId"
                    class="poster-goods-item relative"
                >
                    <i
                    v-if="editingGoodsList.length > 1"
                    class="el-icon-remove text-red absolute remove-icon text-pointer ftsz20"
                    @click="deleteGoods(index)"
                    />
                    <div class="absolute move-icon ftsz18 text-666">
                    <img
                        width="20px"
                        src="https://img.alicdn.com/imgextra/i2/2211227103034/O1CN01fw1rtH1YHcRkh09IY_!!2211227103034.png"
                        v-if="index > 0"
                        class="mgb12 text-pointer"
                        @click="moveUp(index)"
                    />
                    <br />
                    <img
                        width="20px"
                        src="https://img.alicdn.com/imgextra/i2/2211227103034/O1CN01eZ7mS21YHcRmtGTlp_!!2211227103034.png"
                        v-if="index < editingGoodsList.length - 1"
                        class="text-pointer"
                        @click="moveDown(index)"
                    />
                    </div>
                    <div class="relative">
                    <div v-if="item.isTop" class="recommend-tag absolute">
                        推荐
                    </div>
                    <img
                        style="width: 106px; height: 106px; border-radius: 4px;"
                        :src="getMainImage(item.mainImages)"
                        @error="imgOnError($event)"
                    />
                    </div>
                    <div class="mgl12 poster-goods-item-text">
                    <div class="text-ellipsis text-bold ftsz16 text-3c3c3c">{{ item.title }}</div>
                    <div>
                        分销价：
                        <strong
                        v-if="item.levelDistributionPrice === -1"
                        class="text-orange ftsz16"
                        >
                        合作后查看
                        </strong>
                        <strong
                        v-else
                        style="color: #ff0000; font-size: 16px"
                        >
                        ￥{{ item.levelDistributionPrice }}
                        </strong>
                        <!-- 不是合作中但是有分销价的显示合作后更优惠 -->
                    </div>
                    <div class="discounts text-orange ftsz12">
                        合作后可享受更多优惠
                    </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div
                    v-for="item in goodsList"
                    :key="item.baseItemId"
                    class="poster-goods-item"
                >
                    <div class="relative">
                    <div v-if="item.isTop" class="recommend-tag absolute">
                        推荐
                    </div>
                    <img
                        style="width: 106px; height: 106px; border-radius: 4px;"
                        :src="getMainImage(item.mainImages)"
                        crossOrigin="anonymous"
                        @error="imgOnError($event)"
                    />
                    </div>
                    <div class="mgl12 poster-goods-item-text">
                    <div class="text-ellipsis text-bold ftsz16 text-3c3c3c">{{ item.title }}</div>
                    <div>
                        分销价：
                        <strong
                        v-if="item.levelDistributionPrice === -1"
                        class="text-orange ftsz16"
                        >
                        合作后查看
                        </strong>
                        <strong
                        v-else
                        style="color: #ff0000; font-size: 16px"
                        >
                        ￥{{ item.levelDistributionPrice }}
                        </strong>
                        <!-- 不是合作中但是有分销价的显示合作后更优惠 -->
                    </div>
                    <div class="discounts text-orange ftsz12">
                        合作后可享受更多优惠
                    </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <!-- 隐藏的海报，下载用 -->
    <div class="poster-content hide absolute" :id="canvasId">
      <div class="flex space-between">
        <div class="text-left">
          <img
            crossOrigin="anonymous"
            width="72px"
            src="https://img.alicdn.com/imgextra/i2/2211227103034/O1CN01AFY2Yl1YHcRReMH4g_!!2211227103034.png"
            alt=""
          />
          <div class="ftsz20 mgt16 text-bold text-333">
            {{this.cardName || userInfo.companyName}}
          </div>
          <div class="text-grayer mgt16" style="font-size:15px; color: #52555A;">
            邀您看精选好货
          </div>
        </div>
        <div
          class="pd4"
          style="background: #fff; width: 98px; height: 98px; border-radius: 4px;"
        >
          <img
            width="100%"
            :src="`https://scm.superboss.cc/api/wx/unAuth/proxy.json?pic=${wxCodeUrl}`"
          />
        </div>
      </div>
      <div
        v-for="item in goodsList"
        :key="item.baseItemId"
        class="poster-goods-item mgt28"
      >
        <div class="relative">
          <div v-if="item.isTop" class="recommend-tag absolute">
            推荐
          </div>
          <img
            style="width: 106px; height: 106px; border-radius: 4px;"
            :src="getMainImage(item.mainImages)"
            @error="imgOnError($event)"
          />
        </div>
        <div class="mgl12 poster-goods-item-text">
          <div class="text-ellipsis text-bold ftsz16 text-3c3c3c">{{ item.title }}</div>
          <div>
            分销价：
            <strong
              v-if="item.levelDistributionPrice === -1"
              class="text-orange ftsz16"
            >
              合作后查看
            </strong>
            <strong
              v-else
              style="color: #ff0000; font-size: 16px"
            >
              ￥{{ item.levelDistributionPrice }}
            </strong>
            <!-- 不是合作中但是有分销价的显示合作后更优惠 -->
          </div>
          <div class="discounts text-orange ftsz12">
            合作后可享受更多优惠
          </div>
        </div>
      </div>
    </div>
 </div>
    
</template>

<script>
import { mapGetters } from 'vuex';
import { getMainImage } from '@/utils/index';
import no_pic from "@/assets/images/no_pic.png";
export default {
  props: {
    maxHeight: {
        default: 'fit-content',
        type: String,
    },
    cardName: {
        type: String,
        default: '',
    },
    wxCodeUrl: {
        type: String,
        default: '',
    },
    editing: {
        type: Boolean,
        default: false,
    },
    canvasId: {
      default: 'poster',
      type: String,
    },
    goodsList: {
        type: Array,
        default() {
        return []
        }
    },
    editingGoodsList: {
        type: Array,
        default() {
        return []
        }
    },
  },
  data() {
    return {
      dialogVisible: false,
      temp:1
    };
  },
  computed: {
    ...mapGetters([
        "userInfo",
    ]),
  },
  components: {},
  methods: {
    deleteGoods(index){
        this.$emit('deleteGoods', index)
    },
    moveUp(index){
        this.$emit('moveUp', index)
    },
    moveDown(index){
        this.$emit('moveDown', index)
    },
    getMainImage,
    imgOnError(e) {
      console.log(e);
      let img = e.srcElement;
      img.src = no_pic;
      img.onerror = null; //防止闪图
    }
  },
};
</script>

<style lang="scss" scoped>
.poster-content {
width: 520px;
background: linear-gradient(315deg, #9dc7ff 23%, rgb(222, 241, 255) 74%);
padding: 32px;
height: fit-content;
// max-height: calc(100vh - 240px);
overflow-y: auto;
box-shadow: inset 0px -8px 10px 0px rgba(0, 0, 0, 0.06);
&.hide {
    // width: 520px;
    height: fit-content;
    max-height: fit-content;
    transform: scale(0.1) translateY(-250%);
    top: -50%;
    left: 0;
    z-index: -1;
}

.poster-goods-item {
    width: 100%;
    background-color: #fff;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 16px;
    margin-bottom: 8px;
    .remove-icon {
    top: 2px;
    right: 2px;
    }
    .move-icon {
    top: 50%;
    transform: translateY(-50%);
    right: -24px;
    }
    .discounts {
    background-color: #fd88441f;
    padding: 3px 0;
    text-align: center;
    }
    .poster-goods-item-text {
    width: 300px;
    height: 106px;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: space-between;
    }

    .recommend-tag {
    top: 0;
    left: 0;
    color: #fff;
    width: 38px;
    height: 20px;
    line-height: 20px;
    background: #2695FA;
    text-align: center;
    border-top-left-radius: 4px;
    border-bottom-right-radius: 4px;
    }
}
}
</style>
